module.exports = __webpack_public_path__ + "img/slotmachine.bc89f2a8.png";